import script from "./StockTransaction.vue?vue&type=script&setup=true&lang=js"
export * from "./StockTransaction.vue?vue&type=script&setup=true&lang=js"

import "./StockTransaction.vue?vue&type=style&index=0&id=9eef73e8&lang=css"

const __exports__ = script;

export default __exports__